import React, { useState, useEffect } from "react";
import { RiMessage2Fill } from "react-icons/ri";
import { useTheme } from "../components/ThemeContext";

function FloatingActionMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [role, setRole] = useState("");

  const { isDark } = useTheme();

  const toggleMenu = () => setIsOpen(!isOpen);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.id) {
      setRole(user.role);
    }
  }, []);

  const questionAnswers = {
    "How to use as HR": {
      text: "As HR, you can create, assign, and monitor appraisal forms for all staff.",
      link: "https://easbedusg-my.sharepoint.com/personal/harry_hein_eaim_edu_sg/_layouts/15/stream.aspx?id=%2Fpersonal%2Fharry%5Fhein%5Feaim%5Fedu%5Fsg%2FDocuments%2FTutorial%2FHR%20Guide%20with%20Subtitle%2Emp4&referrer=StreamWebApp%2EWeb&referrerScenario=AddressBarCopied%2Eview%2E72ad0477%2D51e2%2D4652%2D8582%2De4d374266684",
      steps: [
        "Log in to the system as HR.",
        "Create or select an appraisal template.",
        "Assign appraisal forms to staff.",
        "Send the appraisal form to individual staff — the system will automatically send an email notification.",
        "Monitor progress and review completed appraisals.",
      ],
    },
    "How to use as Manager": {
      text: "As a manager, you can review and evaluate staff under your supervision. Note: The first signer of the document is the staff member, followed by the supervisor.",
      link: "https://easbedusg-my.sharepoint.com/personal/harry_hein_eaim_edu_sg/_layouts/15/stream.aspx?id=%2Fpersonal%2Fharry%5Fhein%5Feaim%5Fedu%5Fsg%2FDocuments%2FTutorial%2FUser%20Manual%20%28Manager%29%2Emp4&referrer=StreamWebApp%2EWeb&referrerScenario=AddressBarCopied%2Eview%2E4a49447b%2D8449%2D4006%2D8e50%2D715112bae1ae&isDarkMode=false",
      steps: [
        "Log in as a manager.",
        "Assign weights to the performance KPIs.",
        "Go to the 'View Appraisal Form' section.",
        "Review the staff’s PA assessment.",
        "Provide ratings for the assessment.",
        "Give feedback and sign the document.",
        "You can view your self-assessment in 'My Appraisal'.",
      ],
    },
    "How to use as Staff": {
      text: "As a staff member, you can fill out your PA Assessment form and review. Note: The first signer of the document is the staff member, followed by the supervisor.",
      link: "https://easbedusg-my.sharepoint.com/personal/harry_hein_eaim_edu_sg/_layouts/15/stream.aspx?id=%2Fpersonal%2Fharry%5Fhein%5Feaim%5Fedu%5Fsg%2FDocuments%2FTutorial%2FUser%20Manual%20%28Staff%29%2Emp4&referrer=StreamWebApp%2EWeb&referrerScenario=AddressBarCopied%2Eview%2E7eb65958%2Dbfc2%2D44be%2Dabf1%2D3d30c9cbf229",
      steps: [
        "Log in to your account.",
        "Navigate to the 'View PA Assessment' section.",
        "Review and comment on the PA assessment.",
        "If you agree with the assessment, sign the document.",
        "To save your signature, go to 'Signature' under your profile.",
        "After both parties have successfully signed, the document will be locked and can no longer be edited.",
        "You can download and print the PA assessment.",
      ],
    },
  };

  const handleQuestionClick = (question) => {
    setMessages((prev) => [...prev, { from: "user", text: question }]);

    setIsTyping(true);

    setTimeout(() => {
      setIsTyping(false);
      const answer = questionAnswers[question];
      setMessages((prev) => [
        ...prev,
        {
          from: "bot",
          text: answer.text,
          link: answer.link,
          steps: answer.steps,
        },
      ]);
    }, 1500);
  };

  return (
    <div style={{ position: "fixed", bottom: 30, right: 30, zIndex: 1000 }}>
      {isOpen && (
        <div
          style={{
            position: "absolute",
            bottom: 70,
            right: 0,
            backgroundColor: isDark ? "#1e1e1e" : "#fff",
            border: `1px solid ${isDark ? "#444" : "#ccc"}`,
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
            padding: "15px",
            width: "280px",
            maxHeight: "400px",
            overflowY: "auto",
            color: isDark ? "#eee" : "#333",
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              color: isDark ? "#fff" : "#333",
              marginBottom: 10,
            }}
          >
            Ask a Question
          </div>

          <ul style={{ padding: 0, marginBottom: 10, listStyle: "none" }}>
            {Object.keys(questionAnswers)
              .filter((question) => {
                if (role === "Staff") return question === "How to use as Staff";
                return true;
              })
              .map((question, index) => (
                <li
                  key={index}
                  style={{
                    padding: "10px",
                    borderRadius: "8px",
                    backgroundColor: isDark ? "#2c2c2c" : "#f1f3f5",
                    color: isDark ? "#ccc" : "#444",
                    marginBottom: "8px",
                    cursor: "pointer",
                    fontSize: "14px",
                  }}
                  onClick={() => handleQuestionClick(question)}
                >
                  {question}
                </li>
              ))}
          </ul>

          <div
            style={{
              borderTop: "1px solid #eee",
              paddingTop: 10,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {messages.map((msg, idx) => (
              <div
                key={idx}
                style={{
                  backgroundColor:
                    msg.from === "user"
                      ? "#d63384"
                      : isDark
                      ? "#444"
                      : "#6c757d",
                  color: "#fff",
                  padding: "8px 12px",
                  borderRadius: "20px",
                  marginBottom: "6px",
                  maxWidth: "85%",
                  alignSelf: "flex-end",
                  textAlign: "left",
                  fontSize: "13px",
                }}
              >
                <div>{msg.text}</div>

                {msg.steps && (
                  <ol style={{ paddingLeft: "20px", marginTop: "8px" }}>
                    {msg.steps.map((step, stepIndex) => (
                      <li
                        key={stepIndex}
                        style={{ fontSize: "12px", marginBottom: "4px" }}
                      >
                        {step}
                      </li>
                    ))}
                  </ol>
                )}

                {msg.link && (
                  <a
                    href={msg.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      color: "#ffc107",
                      textDecoration: "underline",
                      fontSize: "13px",
                    }}
                  >
                    See full tutorial
                  </a>
                )}
              </div>
            ))}

            {isTyping && (
              <div
                style={{
                  backgroundColor: "#e9ecef",
                  padding: "8px 12px",
                  borderRadius: "20px",
                  display: "inline-block",
                  color: "#666",
                  fontSize: "14px",
                }}
              >
                <span className="dot-typing">Typing</span>
              </div>
            )}
          </div>
        </div>
      )}

      <button
        onClick={toggleMenu}
        style={{
          width: 60,
          height: 60,
          borderRadius: "50%",
          backgroundColor: "#d63384",
          color: "#fff",
          border: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
        }}
      >
        <RiMessage2Fill size={30} />
      </button>
    </div>
  );
}

export default FloatingActionMenu;
